import { TopNav } from "@/components/shell/TopNav";
import { Footer } from "@/components/shell/Footer";
import { Outlet } from "react-router-dom";

export function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <TopNav variant="public" />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
